import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import cn from 'classnames';

import SideBarItems from '@components/common/SideBar/SideBarItems';

import { Icons } from '@icons/icons';

import toSnakeCase from '@utils/toSnakeCase';

import { IMenuItem } from '@components/common/SideBar/interfaces';

import styles from '@components/common/SideBar/SideBar.module.scss';

interface ISideBarGroupsProps {
	menuGroup: IMenuItem;
	openedGroups: string[];
	handleRouteNavigation: (route: string, isActive: boolean) => void;
	toggleMenu: (title: string) => void;
	openSideBar: () => void;
	isOpenSideBar: boolean;
}

const SideBarGroups = ({
	menuGroup,
	openedGroups,
	isOpenSideBar,
	toggleMenu,
	openSideBar,
	handleRouteNavigation,
}: ISideBarGroupsProps) => {
	const location = useLocation();
	const groupDataTestId = toSnakeCase(menuGroup.title);

	const isGroup = !!menuGroup?.groupItems;
	const isActiveGroup = menuGroup.groupItems?.some((item) => location.pathname.includes(item.route))
		|| location.pathname.includes(menuGroup.route);
	const isExpanded = isGroup && openedGroups.includes(menuGroup.title);

	const groupClasses = cn(styles.group, {
		[styles.active]: isActiveGroup,
	});
	const groupOpenedClasses = cn(styles.groupWrapper, {
		[styles.opened]: isOpenSideBar,
		[styles.openedActiveGroup]: isExpanded,
	});

	const onTitleClick = () => {
		if (isGroup) {
			toggleMenu(menuGroup.title);
			openSideBar();
		} else handleRouteNavigation((menuGroup).route, isActiveGroup);
	};

	return (
		<div
			key={menuGroup.title}
			className={groupOpenedClasses}
		>
			<div
				className={groupClasses}
				data-testid={`group_${groupDataTestId}`}
				onClick={onTitleClick}
			>
				{menuGroup.icon
					&& <span className={styles.icon}>
						{isActiveGroup && menuGroup?.activeIcon
							? menuGroup.activeIcon()
							: menuGroup.icon()
						}
					</span>
				}
				<span className={styles.title}>{menuGroup.title}</span>
				{isGroup &&
					<span className={styles.groupChevron}>
						{Icons.chevronDown()}
					</span>
				}
			</div>
			{(menuGroup?.groupItems?.length || menuGroup?.isVendorSpecific) &&
				<SideBarItems
					groupItems={menuGroup.groupItems}
					handleRouteNavigation={handleRouteNavigation}
					isVendorSpecific={menuGroup?.isVendorSpecific}
				/>
			}
		</div>
	);
};

export default memo(SideBarGroups);
